<template>
  <section class="visibility-container" v-if="AllhealthReportChallenge.length">
    <header class="header">
    <div class="vis-right vis-right-text" @click="toggleSideBar">{{
        $t('pages.dashboard.components.foundryHealth.header.details_title')
        }}</div>
    </header>
    <div class="vis-content">
      <div class="speedometer-container">
        <div class="vis-left">
          <div :style="speedometerStyles">
            <VueSpeedometer :fluidWidth="true" :ringWidth="30" :needleHeightRatio="0.7" :maxSegmentLabels="0"
              :segments="75" startColor="#EAA1A3" endColor="#76BA93" :value="VisibilityScoreVal" :minValue="minScore"
              :maxValue="maxScore" needleColor="black" height="200px" />
          </div>
        </div>
      </div>
      <div class="vis-right">
        <p v-if="incompleteChallenge?.taskRoute == 'post_contract'"
          v-html="$t(`pages.dashboard.components.foundryHealth.body.para_title_post_contract`)">
        </p>
        <p v-else-if="incompleteChallenge?.taskRoute == 'edit_foundry'"
          v-html="$t(`pages.dashboard.components.foundryHealth.body.para_title_edit_profile`)">
        </p>
        <p v-else-if="incompleteChallenge.length == 0">
          {{ $t('pages.dashboard.components.foundryHealth.body.para_title_all_complete') }}
        </p>
        <div class="btn-count-div">
          <div class="navigation-btn" v-if="incompleteChallenge.length !== 0">
            <div class="contentItemIcon">
              <span :class="incompleteChallenge.taskIcon"></span>
            </div>
            <span class="taskname-span" @click="changeRoute(incompleteChallenge)">
              {{ incompleteChallenge.taskName }}
            </span>
          </div>
          <div v-if="completedChallenge < AllhealthReportChallenge.length" class="challenge-count">
            <span class="completed-count">{{ completedChallenge }}/{{ AllhealthReportChallenge.length }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
  <common-popup v-if="showPermissionNeededPopup" @popup:crossBtnClick="closePermissionNeededPopup"
    @popup:btn1Click="closePermissionNeededPopup"
    :modalHeading="$t('pages.profile.foundry_profile.permission_denied.title')"
    :modalContent="$t('pages.profile.foundry_profile.permission_denied.description')"
    :modalButton1="$t('pages.profile.foundry_profile.permission_denied.btn1')" :showButton2="false"
    :customBtn1Class="true" id="permission-needed-modal" data-qa-id="permission-needed-modal" />
</template>

<style lang="scss" src="./stylesheet/index.scss" />
<script src="./script.js"></script>